module.exports = __webpack_public_path__ + "static/media/energy7.c3b66781.svg";